import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { useSavedAccount } from "@saleor/components/AppLayout/SavedAccountContext";
import React from "react";

import useStyles from "./styles";

const RemoveAccountDialog = () => {
  const classes = useStyles({});
  const [open, setOpen] = React.useState(true);
  const {
    removeAccount,
    setRemoveAccount,
    handleRemoveAccount
  } = useSavedAccount();

  const handleClose = () => {
    setRemoveAccount(null);
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      classes={{
        paper: classes.dialog
      }}
    >
      <DialogHeader handleClose={handleClose} />
      <DialogContent className={classes.content}>
        <Typography component="p">
          Are you sure you want to remove this account?
        </Typography>
        <Typography component="p" className={classes.contentEmail}>
          {removeAccount}
        </Typography>
      </DialogContent>
      <DialogFooter
        handleClose={handleClose}
        handleRemoveAccount={handleRemoveAccount}
      />
    </Dialog>
  );
};

interface DialogHeaderProps {
  handleClose: () => void;
}

const DialogHeader: React.FC<DialogHeaderProps> = ({ handleClose }) => {
  const classes = useStyles({});

  return (
    <DialogTitle className={classes.title}>
      <IconButton className={classes.closeIcon} onClick={handleClose}>
        <CloseIcon fontSize="small" />
      </IconButton>
      <Typography className={classes.titleText} component="div">
        Remove Account
      </Typography>
    </DialogTitle>
  );
};

interface DialogFooterProps {
  handleClose: () => void;
  handleRemoveAccount: () => void;
}

const DialogFooter: React.FC<DialogFooterProps> = ({
  handleClose,
  handleRemoveAccount
}) => {
  const classes = useStyles({});
  return (
    <DialogActions className={classes.actions}>
      <Button
        id="btnCancel"
        className={classes.cancelButton}
        onClick={handleClose}
      >
        Cancel
      </Button>
      <Button
        id="btnYes"
        className={classes.yesButton}
        variant="contained"
        onClick={handleRemoveAccount}
      >
        Yes
      </Button>
    </DialogActions>
  );
};

RemoveAccountDialog.displayName = "RemoveAccountDialog";
export default RemoveAccountDialog;
